var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navData"}},[_c('screen',{ref:"screen"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }